document.addEventListener('DOMContentLoaded', function () {
    const titles = document.querySelectorAll('.title');
    titles.forEach(title => {
        const text = title.innerHTML.trim();
        title.innerHTML = text.replace(/\s+$/, '') + '&nbsp;<span>.</span>';
    });
});